import React from 'react';
import { useTable } from 'react-table';

// StopTable 컴포넌트
const StopTable = ({ columns, data }) => {
  // useTable 훅을 사용하여 테이블 설정
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

  return (
    <table {...getTableProps()} className='w-full table-fixed'>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id} className='bg-navy text-white'>
            {headerGroup.headers.map(column => (
              <th
                {...column.getHeaderProps()}
                key={column.id} // key를 직접 설정
                className={`b2-t b2-b b2-l p-2 text-center ${
                  column.id === 'start'
                    ? 'w-[100px] sm:w-[150px] md:w-[200px] text-center'
                    : column.id === 'time'
                    ? 'w-[70px] sm:w-[105px] md:w-[140px] text-center'
                    : column.id === 'stopseparate'
                    ? 'w-[120px] sm:w-[180px] md:w-[240px]'
                    : column.id === 'stopreason'
                    ? 'w-[200px] sm:w-[300px] md:w-[400px]'
                    : column.id === 'stopplace'
                    ? 'w-[100px] sm:w-[150px] md:w-[200px]'
                    : column.id === 'detailaction'
                    ? 'w-[160px] sm:w-[240px] md:w-[320px]'
                    : column.id === 'delayreason'
                    ? 'w-[160px] sm:w-[240px] md:w-[320px]'
                    : 'w-auto'
                }`}
              >
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} key={row.id} className='border-b'>
              {row.cells.map(cell => (
                <td
                  {...cell.getCellProps()}
                  key={cell.column.id + cell.row.id} // key를 직접 설정
                  className={`b2-t b2-b b2-l p-2 text-ellipsis overflow-hidden whitespace-nowrap ${
                    cell.column.id === 'start' ? 'text-center' : cell.column.id === 'time' ? 'text-center' : ''
                  }`}
                >
                  {cell.render('Cell')}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default StopTable;
